import { PatchTripType } from '@orbit/api-types'
import api from '@lib/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

export const useUpdateTrip = (tripId: string) => {
	const queryClient = useQueryClient()

	return useMutation<Trip, Error, PatchTripType>({
		mutationFn: async (tripData) => {
			const response = await api.patch<Trip>(`/trips/${tripId}`, tripData)
			return response.data
		},
		onSuccess: (updatedTrip) => {
			queryClient.invalidateQueries({ queryKey: ['trip', tripId] })
			queryClient.invalidateQueries({ queryKey: ['trips'] })
			queryClient.setQueryData(['trip', tripId], updatedTrip)
		},
	})
}

